export default __webpack_public_path__ + "static/media/school01.645f450d.png";